import React, { Component } from "react";
import { connect } from "react-redux";
import * as actions from "../../stores/actions/index";
import { showToast } from "../../helpers/toast.js";
import { Trans, translate } from "react-i18next";
import ContentWrapper from "../Layout/ContentWrapper";
import { Container, Card, CardHeader, CardTitle, CardBody } from "reactstrap";
import CardTool from "../Common/CardTool";
import GatewayTable from "./GatewayTable";
import { apiPath } from "../../config/config";
import { getCommonHeaders } from "../../utils/utilities";
class Gateways extends Component {
  componentDidMount() {
    const { getGatewayList } = this.props;
    getGatewayList(1);
    this.handleThemeChange();

    window.addEventListener("storage", this.handleThemeChange);
  }
  handleThemeChange = () => {
    this.setState({
      themeState:
        document.documentElement.getAttribute("data-theme") === "light"
          ? "light"
          : "dark",
    });
  };

  componentDidUpdate(prevProps) {
    if (prevProps.success !== this.props.success && this.props.success) {
      showToast(this.props.success, "success");
    }
    if (prevProps.error !== this.props.error && this.props.error) {
      showToast(this.props.error, "error");
    }
    if (prevProps.reload !== this.props.reload && this.props.reload) {
      this.props.setModal({ showModal: false, modalName: "", modalData: {} });
      this.props.getGatewayList(1);
    }
  }

  showModal = (modalName, modalData) => {
    const { setModal } = this.props;
    setModal({
      showModal: true,
      modalName,
      modalData,
    });
  };

  editGateway = (gateway) => {
    this.showModal("addEditGateway", { gateway });
  };

  addGateway = () => {
    this.showModal("addEditGateway");
  };

  deleteGateway = (id) => {
    this.showModal("deleteGateway", { id });
  };
  updateFirmware = (id) => {
    this.showModal("updatefirmware", { id });
  };
  uploadFirmware = () => {
    this.showModal("uploadFirmware");
  };
  changePage = (page) => {
    this.props.getGatewayList(page);
  };
  fetchLoraFreq = async () => {
    const headers = getCommonHeaders();
    const response = await fetch(
      `${apiPath.baseUrl}${apiPath.gateway.loraFreq}`,
      {
        method: "POST",
        headers: headers,
        body: JSON.stringify({}),
      }
    );
    console.log(response);
  };

  render() {
    const { gatewayList, meta, loading, t } = this.props;
    const role = localStorage.getItem("role");
    const isLightMode =
      document.documentElement.getAttribute("data-theme") === "light";
    return (
      <ContentWrapper>
        <div className="content-heading">
          <div>
            {t("dashboard.gateways")}
            <small>
              <Trans i18nKey="dashboard.WELCOME"></Trans>
            </small>
          </div>
        </div>

        <Container fluid>
          <div className="d-flex pt-3 pb-3 pl-3 justify-content-end">
            <button
              className="mr-4 float-right"
              style={{
                backgroundColor: isLightMode ? "white" : "#272a34",
                color: isLightMode ? "#272a34" : "white",
                border: isLightMode ? "1px solid #c4c4c4" : "none",
                padding: "6px 20px",
                cursor: "pointer",
                borderRadius: "5px",
              }}
              onClick={this.props.downloadGatways}
            >
              <span className="mr-4">
                <i
                  className="fa fa-download"
                  aria-hidden="true"
                  style={{ color: isLightMode ? "#272a34" : "white" }}
                ></i>
              </span>
              {t("dashboard.downloadGatewaysList")}
            </button>
            {/* <button
              className="mr-2 float-right btn-labeled btn btn-info"
              onClick={this.props.downloadGatways}
            >
              <span className="btn-label">
                <i className="fa fa-plus" aria-hidden="true"></i>
              </span>
              {t("dashboard.downloadGatewaysList")}
            </button> */}
            {role === "super_admin" ? (
              <>
                <button
                  className="mr-2 float-right btn-labeled btn btn-info"
                  onClick={() => this.props.getGatewayList(1)}
                >
                  {t("dashboard.refreshTable")}
                </button>
                <button
                  className="mr-2 float-right btn-labeled btn btn-info"
                  onClick={this.uploadFirmware.bind(this)}
                >
                  <span className="btn-label">
                    <i className="fa fa-upload" aria-hidden="true"></i>
                  </span>
                  {t("dashboard.upload")} FW
                </button>
              </>
            ) : (
              // <button
              //   className="mr-2 float-right btn-labeled btn btn-info"
              //   onClick={this.addGateway.bind(this)}
              // >
              //   <span className="btn-label">
              //     <i className="fa fa-plus" aria-hidden="true"></i>
              //   </span>
              //   {t("dashboard.add")}
              // </button>
              <button
                className=" float-right"
                style={{
                  backgroundColor: isLightMode ? "white" : "#272a34",
                  color: isLightMode ? "#272a34" : "white",
                  border: isLightMode ? "1px solid #c4c4c4" : "none",
                  padding: "6px 20px",
                  cursor: "pointer",
                  borderRadius: "5px",
                }}
                onClick={this.addGateway.bind(this)}
              >
                <span className="mr-4">
                  <i
                    className="fa fa-plus"
                    aria-hidden="true"
                    style={{ color: isLightMode ? "#272a34" : "white" }}
                  ></i>
                </span>
                {t("dashboard.add")}
              </button>
            )}

            {/* <button
              className="mr-4 float-right"
              style={{
                backgroundColor: isLightMode ? "white" : "#272a34",
                color: isLightMode ? "#272a34" : "white",
                border: isLightMode ? "1px solid #c4c4c4" : "none",
                padding: "6px 20px",
                cursor: "pointer",
                borderRadius: "5px",
              }}
              onClick={this.fetchLoraFreq}
            >
              <span className="mr-4">
                <i
                  className="fa fa-plus"
                  aria-hidden="true"
                  style={{ color: isLightMode ? "#272a34" : "white" }}
                ></i>
              </span>
              Fetch Lora Frequencies
            </button> */}
          </div>
          <Card className="card-default">
            <CardHeader className="d-flex align-items-center justify-content-between">
              <CardTitle>{t("dashboard.gateways")}</CardTitle>
              <CardTool
                refresh
                onRefresh={(_, done) => setTimeout(done, 2000)}
              />
            </CardHeader>
            <div
              style={{
                height: "1px",
                width: "100%",
                background: "#ccc",
              }}
            />
            <CardBody>
              {gatewayList && gatewayList.length > 0 && (
                <GatewayTable
                  pagination={meta.pagination}
                  gateways={gatewayList}
                  editGateway={this.editGateway}
                  deleteGateway={this.deleteGateway}
                  changePage={(page) => this.changePage(page)}
                  updateFirmware={this.updateFirmware}
                ></GatewayTable>
              )}
              {loading ? <h3 className="text-center">Loading...</h3> : ""}
            </CardBody>
          </Card>
        </Container>
      </ContentWrapper>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loading: state.gateways.loading,
    gatewayList: state.gateways.gatewayList,
    meta: state.gateways.meta,
    error: state.gateways.error,
    success: state.gateways.success,
    reload: state.gateways.reload,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getGatewayList: (data) => dispatch(actions.getGatewayList(data)),
    setModal: (data) => dispatch(actions.setModal(data)),
    downloadGatways: () => dispatch(actions.downloadGatways()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate("translations")(Gateways));
